import { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../User/UserContext";
import ImagesInSQSItem from "./ImagesInSQSItem";

export default function ImagesInSQS({ inSQS, setInSQS, setRecentlyAddedPaths }) {
	const { api, token } = useContext(UserContext);
	const [progress, setProgress] = useState(0);

	const inSQSRef = useRef(inSQS);

	useEffect(() => {
		inSQSRef.current = inSQS;
	}, [inSQS]);

	useEffect(() => {
		if (!inSQS || inSQS.length === 0) return;

		const totalDurationMs = 10000;
		const intervalMs = 100;
		const increment = 100 / (totalDurationMs / intervalMs);

		let current = 0;
		const id = setInterval(() => {
			current += increment;
			if (current >= 100) {
				current = 0;
			}
			setProgress(current);
		}, intervalMs);

		return () => clearInterval(id);
	}, [inSQS]);

	useEffect(() => {
		let cancelled = false;

		const wait = (ms) =>
			new Promise((resolve) => {
				setTimeout(resolve, ms);
			});

		const loop = async () => {
			await wait(5000);

			while (!cancelled) {
				const queue = inSQSRef.current;

				if (queue && queue.length > 0) {
					try {
						const res = await fetch(api + "/project/check-sqs", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
								Authorization: "Bearer " + token,
							},
							body: JSON.stringify({ sqsIds: queue.map((m) => m.id) }),
							mode: "cors",
						});

						if (res.ok) {
							const data = await res.json();

							if (data && Array.isArray(data.results) && data.results.length > 0) {
								const idsToFilter = [];
								const imagesToAdd = [];

								data.results.forEach((item) => {
									if (item.dropbox_path) {
										idsToFilter.push(item.id);
										imagesToAdd.push(item.dropbox_path);
									}
								});

								if (idsToFilter.length > 0) {
									setInSQS((prev) => prev.filter((item) => !idsToFilter.includes(item.id)));
									setRecentlyAddedPaths((prev) => [...imagesToAdd, ...prev]);
								}
							}
						}
					} catch (err) {
						console.error("check-sqs polling error:", err);
					}
				}

				await wait(5000);
			}
		};

		loop();

		return () => {
			cancelled = true;
		};
	}, [api, token, setInSQS, setRecentlyAddedPaths]);

	if (!inSQS || inSQS.length === 0) {
		return null;
	}

	return (
		<>
			{inSQS.map((mapData) => (
				<ImagesInSQSItem key={mapData.id} />
			))}
		</>
	);
}
